import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { ETheme } from "../../../shared/enums/user/ETheme";
import { darkTheme, lightTheme } from "../../../shared/mui/theme";
import { TroubleshootOutlined, VisibilityOutlined } from "@mui/icons-material";

export const useEmailListColumns = () => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  return [
    { field: "id", headerName: t("general.id"), width: 80 },
    {
      field: "name",
      headerName: t("invoice.itemName"),
      flex: 1,
      minWidth: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            navigate(`/email-list/preview/${params?.row?.id}`);
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "category",
      headerName: t("emails.category"),
      width: 250,
    },
    {
      field: "language",
      headerName: t("emails.language"),
      width: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {t(`language.${params?.value}`)}
        </div>
      ),
    },

    {
      field: "recipients",
      headerName: t("emails.recipients"),
      width: 100,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {params?.value?.length}
        </div>
      ),
    },

    {
      field: "actions",
      headerName: t("general.action"),
      width: 150,
      sortable: false,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={() => {
              navigate(`/email-list/stats/${params?.row?.id}`);
            }}
          >
            <TroubleshootOutlined
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={() => {
              navigate(`/email-list/preview/${params?.row?.id}`);
            }}
          >
            <VisibilityOutlined
              sx={{ ml: "10px" }}
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>
        </Box>
      ),
    },
  ];
};
